module.exports = __webpack_public_path__ + "static/media/icon_messenger.86655237.png";